// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { SwitchContainer, SwitchButton } from '../styles/UnitSwitch.style';

const UnitSwitch = ({ selectedUnit, onUnitChange, activeDepartment, hideUnitMetic }) => {
  if (!isEmpty(hideUnitMetic) && hideUnitMetic.includes(activeDepartment)) {
    return null;
  }

  const handleToggle = () => {
    const newUnit = selectedUnit === 'US' ? 'METRIC' : 'US';
    onUnitChange(newUnit);
  };

  return (
    <SwitchContainer className="dynamic-unit-switch-section">
      <SwitchButton active={selectedUnit === 'US'} onClick={handleToggle}>
        <span>US</span>
      </SwitchButton>
      <SwitchButton active={selectedUnit === 'METRIC'} onClick={handleToggle}>
        <span>METRIC</span>
      </SwitchButton>
    </SwitchContainer>
  );
};

UnitSwitch.propTypes = {
  selectedUnit: PropTypes.string.isRequired,
  onUnitChange: PropTypes.func.isRequired,
  activeDepartment: PropTypes.string.isRequired,
  hideUnitMetic: PropTypes.shape([]).isRequired,
};

export default UnitSwitch;
export { UnitSwitch as UnitSwitchVanilla };
